<app-welcome></app-welcome>
<main id="main">
  <contest-introduction></contest-introduction>
  <about-contest></about-contest>
  <contest-winners *ngIf="contestWinners" [contestWinners]="contestWinners"></contest-winners>
  <virtual-gallery *ngIf="contestWinners" [contestWinners]="contestWinners"></virtual-gallery>
  <testimonials></testimonials>
</main>
<app-footer></app-footer>
